import { TagStatus } from '../../graphql';

export interface AssetTag {
  id: string;
  tagCode: string;
  status: TagStatus;
}
